let language = {
    712307: "The invoice download function is not supported for the current order. Please download the invoice from the latest completed payment order"
};

export { language }